var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('SlotContainer',{attrs:{"refName":"slot-validation-box","slotName":"validation-box","wrapperClass":"webcomponent-validation-box"}},[_vm._t("validation-box",null,{"slot":"validation-box"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }